var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomersAction, orderCountDetail, orderWiseProductsData } from "../../reduxStore/actions/salesRepDataAction";
import store from "../../reduxStore/store";
import { isLoading } from "../../services/behaviorSubjectService";
import { useDeviceQueries } from "../../shared/Utilites";
export function MyCustomerBL() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var isMobile = useDeviceQueries();
    var shopCurrency = store.getState().salesRepData.loggedInRepDetails.shopCurrency;
    var currency = store.getState().salesRepData.loggedInRepDetails.currency;
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    var selectFeatures = ((_a = salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.select) ? salesRepData.baseData.select : {};
    var _h = useState((_c = (_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _b === void 0 ? void 0 : _b.customers) !== null && _c !== void 0 ? _c : []), customerArray = _h[0], setCustomerArray = _h[1];
    var _j = useState(store.getState().salesRepData.baseData.hideCompanyAddressInAddCustomer), hideCompanySection = _j[0], setHideCompanySection = _j[1];
    var _k = useState("asc"), orderType = _k[0], setOrderType = _k[1];
    var _l = useState("name"), byColumnName = _l[0], setByColumnName = _l[1];
    var _m = useState(""), filterState = _m[0], setFilterState = _m[1];
    var _o = useState(false), openDialog = _o[0], setOpenDialog = _o[1];
    var _p = useState(false), orderCountDialog = _p[0], setOrderCountDialog = _p[1];
    var _q = useState(true), isAddCustomer = _q[0], setIsAddCustomer = _q[1];
    var _r = useState(true), orderCountFlag = _r[0], setOrderCountFlag = _r[1];
    var _s = useState([]), orderDetailsArray = _s[0], setOrderDetailsArray = _s[1];
    var _t = useState([]), orderWiseProductDetailsArray = _t[0], setOrderWiseProductDetailsArray = _t[1];
    var _u = useState(), activeClientObj = _u[0], setActiveClientObj = _u[1];
    var _v = useState(false), loadingDisabled = _v[0], setLoadingDisabled = _v[1];
    var _w = useState(""), singleCustomerId = _w[0], setSingleCustomerId = _w[1];
    var _x = useState(false), isSearching = _x[0], setIsSearching = _x[1];
    var _y = useState(false), isPagination = _y[0], setIsPagination = _y[1];
    var _z = useState(""), currentSearchTerm = _z[0], setCurrentSearchTerm = _z[1];
    var _0 = useState({
        endCursor: ((_d = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _d === void 0 ? void 0 : _d.endCursor) || "",
        startCursor: ((_e = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _e === void 0 ? void 0 : _e.startCursor) || "",
        hasNext: ((_f = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _f === void 0 ? void 0 : _f.hasNext) || false,
        hasPrevious: ((_g = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _g === void 0 ? void 0 : _g.hasPrevious) || false,
    }), paginationState = _0[0], setPaginationState = _0[1];
    var filteredArray = __spreadArray([], customerArray, true);
    var tempOrderType = "";
    var activeClientId;
    isLoading.subscribe(function (data) {
        if (data !== loadingDisabled)
            setLoadingDisabled(data);
    });
    var HeaderNames = [
        {
            id: "firstName",
            label: t("myCustomers_table1Column1"),
            inlineCSS: { width: "30%" },
        },
        {
            id: "companyName",
            label: t("myCustomers_table1Column2"),
            inlineCSS: { width: "25%" },
        },
        {
            id: "emailId",
            label: t("myCustomers_table1Column3"),
            inlineCSS: { width: "30%" },
        },
        { id: "orderCount", label: t("myCustomers_table1Column4"), inlineCSS: { width: "15%", textAlign: "center" } },
    ];
    var OrderDetailsHeaderNames = [
        {
            label: t("myOrders_table1Column1"),
        },
        {
            label: t("myOrders_table1Column2"),
        },
        {
            label: t("myOrders_table1Column4"),
        },
        {
            label: t("myOrders_table1Column5"),
        },
        {
            label: t("myOrders_content1") + "(" + shopCurrency + ")",
        },
        {
            label: t("myOrders_content3") + "(" + shopCurrency + ")",
        },
        {
            label: t("myOrders_content2") + "(" + shopCurrency + ")",
        },
        {
            label: t("myOrders_content4") + "(" + shopCurrency + ")",
        },
    ];
    var ProductDetailsHeaderNames = [
        {
            label: t("myOrders_table2Column1"),
        },
        {
            label: t("myOrders_table2Column2"),
        },
        {
            label: t("variant_title"),
        },
        {
            label: "SKU",
        },
        {
            label: t("myOrders_table2Column3"),
        },
        {
            label: t("myOrders_table2Column4") + "(" + shopCurrency + ")",
        },
        {
            label: t("viewProductModelColumn6") + "(" + shopCurrency + ")",
        },
        {
            label: t("myOrders_table2Column5"),
        },
        {
            label: t("myOrders_table2Column6"),
        },
        {
            label: t("myOrders_table2Column7") + "(" + shopCurrency + ")",
        },
    ];
    useEffect(function () {
        sortHeaderData("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var _a;
        if (((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _a === void 0 ? void 0 : _a.customers) && salesRepData.repAllCustomers.customers.length > 0) {
            updateLocalCustomerState(salesRepData.repAllCustomers);
        }
        else {
            fetchAllCustomers({ isNextPage: true, isSaveToStore: true });
        }
    }, []);
    var sortHeaderData = function (columnName) {
        if (columnName === byColumnName) {
            tempOrderType = orderType === "asc" ? "desc" : "asc";
            setOrderType(tempOrderType);
        }
        else {
            tempOrderType = "asc";
            setOrderType(tempOrderType);
            setByColumnName(columnName);
        }
        sortColumnData(columnName);
    };
    var sortColumnData = function (columnName) {
        var aTemp, bTemp;
        if (tempOrderType === "asc" && (customerArray === null || customerArray === void 0 ? void 0 : customerArray.length) > 0) {
            customerArray.sort(function (a, b) {
                if (typeof a[columnName] && typeof b[columnName] === "string") {
                    if (a[columnName] !== undefined && a[columnName] !== null && a[columnName] !== "" && b[columnName] !== undefined && b[columnName] !== null && b[columnName] !== "") {
                        aTemp = a[columnName].toLowerCase();
                        bTemp = b[columnName].toLowerCase();
                    }
                    return aTemp > bTemp ? 1 : -1;
                }
                else {
                    return a[columnName] - b[columnName];
                }
            });
        }
        else if (tempOrderType === "desc" && (customerArray === null || customerArray === void 0 ? void 0 : customerArray.length) > 0) {
            customerArray.sort(function (a, b) {
                if (typeof a[columnName] && typeof b[columnName] === "string") {
                    if (a[columnName] !== undefined && a[columnName] !== null && a[columnName] !== "" && b[columnName] !== undefined && b[columnName] !== null && b[columnName] !== "") {
                        aTemp = a[columnName].toLowerCase();
                        bTemp = b[columnName].toLowerCase();
                    }
                    return aTemp < bTemp ? 1 : -1;
                }
                else {
                    return b[columnName] - a[columnName];
                }
            });
        }
        setCustomerArray(customerArray);
    };
    var applyFilter = function (e) {
        var searchTerm = e.target.value;
        if (searchTerm) {
            searchTerm = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim();
            setFilterState(searchTerm);
            filteredArray = filteredArray === null || filteredArray === void 0 ? void 0 : filteredArray.filter(function (data) {
                var _a, _b, _c, _d;
                var customerName = ((_a = data === null || data === void 0 ? void 0 : data.ClientName) !== null && _a !== void 0 ? _a : "").trim() ? data === null || data === void 0 ? void 0 : data.ClientName : (_b = data === null || data === void 0 ? void 0 : data.CustomerMailid) !== null && _b !== void 0 ? _b : "";
                return (((_c = customerName === null || customerName === void 0 ? void 0 : customerName.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase())) ||
                    (data.companyName !== undefined && data.companyName !== null && data.companyName !== "" && ((_d = data.companyName.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes(searchTerm.toLowerCase()))));
            });
            setCustomerArray(filteredArray);
        }
    };
    var getOrderCountDetails = function (clientId) { return __awaiter(_this, void 0, void 0, function () {
        var orderCountDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    activeClientId = clientId;
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(orderCountDetail(clientId))];
                case 1:
                    orderCountDetails = _a.sent();
                    setOrderCountFlag(true);
                    setOrderDetailsArray(orderCountDetails.clientallorders ? orderCountDetails.clientallorders : []);
                    isLoading.next(false);
                    setOrderCountDialog(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var getOrderWiseProductsData = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var params, orderWiseProducts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        order_id: item.order_id,
                        clientId: activeClientId,
                    };
                    isLoading.next(true);
                    setActiveClientObj(item);
                    return [4 /*yield*/, dispatch(orderWiseProductsData(params))];
                case 1:
                    orderWiseProducts = _a.sent();
                    setOrderCountFlag(false);
                    setOrderWiseProductDetailsArray(orderWiseProducts.ProductDetails);
                    isLoading.next(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleNewCustomerModal = function () {
        setOpenDialog(!openDialog);
    };
    var handleSingleCustomerId = function (id) {
        setSingleCustomerId(id);
        setOpenDialog(true);
        setIsAddCustomer(false);
    };
    var OpenAddCustomerModal = function () {
        setOpenDialog(true);
        setIsAddCustomer(true);
    };
    var updateLocalCustomerState = function (customerData) {
        if (customerData && (customerData === null || customerData === void 0 ? void 0 : customerData.customers)) {
            setCustomerArray(customerData.customers);
            setPaginationState({
                endCursor: (customerData === null || customerData === void 0 ? void 0 : customerData.endCursor) || "",
                startCursor: (customerData === null || customerData === void 0 ? void 0 : customerData.startCursor) || "",
                hasNext: (customerData === null || customerData === void 0 ? void 0 : customerData.hasNext) || false,
                hasPrevious: (customerData === null || customerData === void 0 ? void 0 : customerData.hasPrevious) || false,
            });
        }
    };
    var handleKeyPress = function (event) {
        if (event.key === "Enter") {
            handleSearchCustomers(filterState);
        }
    };
    var changeCustomerSearch = function (e) {
        if (e.target.value) {
            setFilterState(e.target.value);
        }
        else {
            setFilterState("");
            if (currentSearchTerm) {
                handleSearchCustomers();
            }
        }
    };
    var handleSearchCustomers = function (searchTerm) { return __awaiter(_this, void 0, void 0, function () {
        var searchItem, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!searchTerm) return [3 /*break*/, 6];
                    isLoading.next(true);
                    searchItem = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim();
                    setIsSearching(true);
                    setCurrentSearchTerm(searchItem);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchAllCustomers({
                            isNextPage: true,
                            searchString: searchItem,
                            endCursor: "",
                            startCursor: "",
                            isSaveToStore: false,
                        })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    console.error("Error searching customers:", error_1);
                    return [3 /*break*/, 5];
                case 4:
                    isLoading.next(false);
                    setIsSearching(false);
                    return [7 /*endfinally*/];
                case 5: return [3 /*break*/, 7];
                case 6:
                    setIsSearching(false);
                    setCurrentSearchTerm("");
                    if (((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _a === void 0 ? void 0 : _a.customers) && salesRepData.repAllCustomers.customers.length > 0) {
                        updateLocalCustomerState(salesRepData.repAllCustomers);
                    }
                    _b.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handlePageChange = function (direction) { return __awaiter(_this, void 0, void 0, function () {
        var isNextPage, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    isLoading.next(true);
                    setIsPagination(true);
                    isNextPage = direction === "next";
                    return [4 /*yield*/, fetchAllCustomers({
                            isNextPage: isNextPage,
                            startCursor: paginationState.startCursor,
                            endCursor: paginationState.endCursor,
                            searchString: currentSearchTerm,
                            isSaveToStore: false,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error in pagination:", error_2);
                    return [3 /*break*/, 4];
                case 3:
                    isLoading.next(false);
                    setIsPagination(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Reload the list (page 1, no active search) after a new customer is added so the
    // newly created customer is reflected immediately without a manual browser refresh.
    var refreshCustomerListAfterAdd = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFilterState("");
                    setCurrentSearchTerm("");
                    setIsSearching(false);
                    return [4 /*yield*/, fetchAllCustomers({
                            isNextPage: true,
                            startCursor: "",
                            endCursor: "",
                            isSaveToStore: true,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchAllCustomers = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var apiParams, response, error_3;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, 3, 4]);
                    isLoading.next(true);
                    apiParams = {
                        isNextPage: (_a = params === null || params === void 0 ? void 0 : params.isNextPage) !== null && _a !== void 0 ? _a : true,
                        startCursor: (params === null || params === void 0 ? void 0 : params.startCursor) || "",
                        endCursor: (params === null || params === void 0 ? void 0 : params.endCursor) || "",
                        isShowAllCustomer: (_b = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.showAllCustomer) !== null && _b !== void 0 ? _b : false,
                        isSaveToStore: (_c = params === null || params === void 0 ? void 0 : params.isSaveToStore) !== null && _c !== void 0 ? _c : true,
                    };
                    if (params === null || params === void 0 ? void 0 : params.searchString) {
                        apiParams.searchString = params.searchString;
                    }
                    return [4 /*yield*/, getAllCustomersAction(apiParams)(dispatch)];
                case 1:
                    response = _d.sent();
                    if (response && (response === null || response === void 0 ? void 0 : response.customers)) {
                        updateLocalCustomerState(response);
                    }
                    return [2 /*return*/, response];
                case 2:
                    error_3 = _d.sent();
                    console.error("Error fetching customers:", error_3);
                    return [2 /*return*/, null];
                case 3:
                    isLoading.next(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return {
        openDialog: openDialog,
        handleNewCustomerModal: handleNewCustomerModal,
        filterState: filterState,
        applyFilter: applyFilter,
        HeaderNames: HeaderNames,
        sortHeaderData: sortHeaderData,
        byColumnName: byColumnName,
        orderType: orderType,
        customerArray: customerArray,
        setOpenDialog: setOpenDialog,
        isAddCustomer: isAddCustomer,
        setIsAddCustomer: setIsAddCustomer,
        getOrderCountDetails: getOrderCountDetails,
        orderCountDialog: orderCountDialog,
        setOrderCountDialog: setOrderCountDialog,
        OrderDetailsHeaderNames: OrderDetailsHeaderNames,
        getOrderWiseProductsData: getOrderWiseProductsData,
        orderDetailsArray: orderDetailsArray,
        orderWiseProductDetailsArray: orderWiseProductDetailsArray,
        orderCountFlag: orderCountFlag,
        setOrderCountFlag: setOrderCountFlag,
        ProductDetailsHeaderNames: ProductDetailsHeaderNames,
        activeClientObj: activeClientObj,
        loadingDisabled: loadingDisabled,
        t: t,
        shopCurrency: shopCurrency,
        hideCompanySection: hideCompanySection,
        isMobile: isMobile,
        setCustomerArray: setCustomerArray,
        singleCustomerId: singleCustomerId,
        OpenAddCustomerModal: OpenAddCustomerModal,
        handleSingleCustomerId: handleSingleCustomerId,
        currency: currency,
        handleSearchCustomers: handleSearchCustomers,
        handlePageChange: handlePageChange,
        refreshCustomerListAfterAdd: refreshCustomerListAfterAdd,
        isSearching: isSearching,
        isPagination: isPagination,
        totalCount: (customerArray === null || customerArray === void 0 ? void 0 : customerArray.length) || 0,
        paginationState: paginationState,
        changeCustomerSearch: changeCustomerSearch,
        currentSearchTerm: currentSearchTerm,
        handleKeyPress: handleKeyPress,
    };
}
export function CssConstants() {
    var ProductTableCSS = {
        padding: "10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
    };
    return ProductTableCSS;
}
